import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { Eye, EyeOff } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { apiError } from '../lib/api';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.dismiss();
      // Kalau tadi datang dari pintasan /scan, lanjutkan ke sana.
      const asal = location.state?.from;
      navigate(asal ? `${asal.pathname}${asal.search || ''}` : '/', { replace: true });
    } catch (err) {
      toast.error(apiError(err, 'Login gagal'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ivory flex items-center justify-center px-4" data-testid="login-page">
      <div className="w-full max-w-sm">
        <div className="bg-white rounded-3xl border border-border shadow-soft overflow-hidden">
          <div className="bg-choco px-8 pt-9 pb-8 text-center relative">
            <img src="/logo.png" alt="Deyran Gallery" className="w-16 h-16 rounded-full object-cover mx-auto ring-2 ring-gold/60" />
            <p className="font-display text-2xl text-ivory tracking-wide mt-4">DEYRAN GALLERY</p>
            <p className="text-gold/80 text-[10px] uppercase tracking-[0.25em] mt-1.5">Rental Kebaya & Baju Bodo</p>
            <div className="absolute bottom-0 inset-x-0 h-1 songket-strip opacity-70" />
          </div>
          <form onSubmit={submit} className="p-8 space-y-5">
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider text-mocha">Email</label>
              <input
                data-testid="login-email-input"
                type="email"
                required
                autoCapitalize="none"
                autoCorrect="off"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 w-full rounded-xl border border-input bg-ivory/50 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-brown/30 transition-shadow"
                placeholder="email@anda.com"
              />
            </div>
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider text-mocha">Password / PIN</label>
              <div className="relative mt-2">
                <input
                  data-testid="login-password-input"
                  type={showPw ? 'text' : 'password'}
                  required
                  autoCapitalize="none"
                  autoCorrect="off"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full rounded-xl border border-input bg-ivory/50 px-4 py-3 pr-11 text-sm outline-none focus:ring-2 focus:ring-brown/30 transition-shadow"
                  placeholder="••••••"
                />
                <button
                  type="button"
                  data-testid="toggle-password-visibility"
                  onClick={() => setShowPw(!showPw)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-mocha hover:text-brown"
                >
                  {showPw ? <EyeOff size={17} /> : <Eye size={17} />}
                </button>
              </div>
            </div>
            <button
              data-testid="login-submit-button"
              type="submit"
              disabled={loading}
              className="w-full rounded-xl bg-brown text-white py-3.5 font-semibold text-sm hover:bg-brown-med active:scale-[0.98] transition-all duration-150 disabled:opacity-60"
            >
              {loading ? 'Memeriksa…' : 'Masuk'}
            </button>
            <p className="text-[11px] text-mocha text-center leading-relaxed">
              Salah 5x berturut-turut = jeda 1 menit. Password yang benar tetap bisa masuk.
            </p>
          </form>
        </div>
        <p className="text-center text-xs text-mocha mt-6">Sistem operasional internal Deyran Gallery</p>
      </div>
    </div>
  );
}
